import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AIStrategyQuiz from "./quizzes/aistrategy/AIStrategyQuiz";
import AutomationQuiz from "./quizzes/automation/AutomationQuiz";
import BusinessAuditQuiz from "./quizzes/businessaudit/BusinessAuditQuiz";
import CloudQuiz from "./quizzes/cloud/CloudQuiz";
import ContentGenQuiz from "./quizzes/contentgen/ContentGenQuiz";
import ContentMarketingQuiz from "./quizzes/contentmarketing/ContentMarketingQuiz";
import CRMQuiz from "./quizzes/crm/CRMQuiz";
import CustomerAIQuiz from "./quizzes/customerai/CustomerAIQuiz";
import DataAnalysisQuiz from "./quizzes/dataanalysis/DataAnalysisQuiz";
import DiagnosticQuiz from "./quizzes/diagnostic/DiagnosticQuiz";
import EmailMarketingQuiz from "./quizzes/emailmarketing/EmailMarketingQuiz";
import GrowthQuiz from "./quizzes/growth/GrowthQuiz";
import InteractiveQuiz from "./quizzes/interactive/InteractiveQuiz";
import PredictiveQuiz from "./quizzes/predictive/PredictiveQuiz";
import ProcessAutoQuiz from "./quizzes/processauto/ProcessAutoQuiz";
import ReputationQuiz from "./quizzes/reputation/ReputationQuiz";
import SEOQuiz from "./quizzes/seo/SEOQuiz";
import SocialMediaQuiz from "./quizzes/socialmedia/SocialMediaQuiz";
import TechnologyQuiz from "./quizzes/technology/TechnologyQuiz";
import WebDevQuiz from "./quizzes/webdev/WebDevQuiz";
import WorkplaceQuiz from "./quizzes/workplace/WorkplaceQuiz";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/aistrategy/*" element={<AIStrategyQuiz />} />
          <Route path="/automation/*" element={<AutomationQuiz />} />
          <Route path="/businessaudit/*" element={<BusinessAuditQuiz />} />
          <Route path="/cloud/*" element={<CloudQuiz />} />
          <Route path="/contentgen/*" element={<ContentGenQuiz />} />
          <Route
            path="/contentmarketing/*"
            element={<ContentMarketingQuiz />}
          />
          <Route path="/crm/*" element={<CRMQuiz />} />
          <Route path="/customer_ai/*" element={<CustomerAIQuiz />} />
          <Route path="/dataanalysis/*" element={<DataAnalysisQuiz />} />
          <Route
            path="/diagnostic_make_it_work/*"
            element={<DiagnosticQuiz />}
          />
          <Route path="/emailmarketing/*" element={<EmailMarketingQuiz />} />
          <Route path="/diagnostic_make_it_real/*" element={<GrowthQuiz />} />
          <Route path="/interactive/*" element={<InteractiveQuiz />} />
          <Route path="/predictive/*" element={<PredictiveQuiz />} />
          <Route path="/processauto/*" element={<ProcessAutoQuiz />} />
          <Route path="/reputation/*" element={<ReputationQuiz />} />
          <Route path="/seo/*" element={<SEOQuiz />} />
          <Route path="/socialmedia/*" element={<SocialMediaQuiz />} />
          <Route path="/technology/*" element={<TechnologyQuiz />} />
          <Route path="/webdev/*" element={<WebDevQuiz />} />
          <Route path="/workplace/*" element={<WorkplaceQuiz />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
